import CompanyDetails from './CompanyDetails.jsx'
import Modules from './Modules.jsx'
import AccessAndFeatures from './AccessAndFeatures.jsx'

const GeneralDetails = ({ companyDetails, ssoAccessLabel, ssoAccessPositive }) => (
  <>
    <CompanyDetails companyDetails={companyDetails} />
    <Modules companyDetails={companyDetails} />
    <AccessAndFeatures
      companyDetails={companyDetails}
      ssoAccessLabel={ssoAccessLabel}
      ssoAccessPositive={ssoAccessPositive}
    />
  </>
)

export default GeneralDetails
